import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';

import { Nillable } from '@web/utils';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { PublicBoxTileImageComponent } from '../../components/public-box-tile-image/public-box-tile-image.component';
import { PublicBoxTileDetailsComponent } from '../../components/public-box-tile-details/public-box-tile-details.component';
import { PublicAvailability } from '@web/shared/module/shop';

@Component({
  selector: 'app-public-box-tile',
  imports: [
    RouterLinkComponent,
    PublicBoxTileImageComponent,
    PublicBoxTileDetailsComponent,
  ],
  templateUrl: './public-box-tile.component.html',
  styleUrl: './public-box-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxTileComponent {
  public readonly date = input.required<Date>();
  public readonly imageAlt = input<Nillable<string>>();
  public readonly imageSrc = input<Nillable<string>>();
  public readonly name = input.required<string>();
  public readonly rating = input.required<number>();
  public readonly slug = input.required<string>();
  public readonly availability = input.required<PublicAvailability>();
  public readonly votes = input.required<number>();
  public readonly routerLinkParams = this.routerLinkParamsSignal();

  protected readonly Route = Route;

  private routerLinkParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Slug]: this.slug(),
    }));
  }
}
